/** Il portale studi (commercialista e consulente del lavoro) si apre all'indirizzo /studi (148). */
export function eStudi(percorso: string): boolean {
  return /^\/studi\/?$/i.test(percorso);
}
